import { render, staticRenderFns } from "./WalletTable.vue?vue&type=template&id=3a8a2eba&scoped=true"
import script from "./WalletTable.vue?vue&type=script&lang=js"
export * from "./WalletTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8a2eba",
  null
  
)

export default component.exports